'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PlusOutlined = _interopRequireDefault(require('./lib/icons/PlusOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PlusOutlined;
exports.default = _default;
module.exports = _default;